import styled from "styled-components";
import menteeMatchArrow1 from './menteeMatchArrow1.png';
import menteeMatchArrow2 from './menteeMatchArrow2.png';

export const MenteeMatchModalTitle = styled.div`
    color: #302F2F;
    text-align: center;
    font-family: "Nunito Sans";
    font-size: 18px;
    font-weight: 500;
        @media ( max-width: 640px ) {
            br {
                display:none;
            }
        }
`;

export const MenteeMatchRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 27px 60px 0;
        @media(max-width: 1440px) {
            padding: 0;
        }
`;

export const MenteeMatchCol = styled.div`
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
    width:150px;
    position:relative;
    flex-direction: column;
    align-items: center;
    gap: 6px;
        @media ( max-width: 640px ) {
            width:120px;
        }
        img {
            width:80px;
            height:80px;
        }
        h3 {
            color: #302F2F;
            text-align: center;
            font-family: "Nunito Sans";
            font-size: 16px;
            line-height:1;
            font-weight: 600;
            text-align:center;
            margin:10px 0 5px 0;
        }
        span {
            display:flex;
            justify-content:center;
            width:100%;
            color: #757575;
            font-family: "Nunito Sans";
            font-size: 14px;
            font-weight: 400;
        }
        &:first-child:before {
            content:'';
            position:absolute;
            right:-100px;
            bottom:20px;
            width:80px;
            height:39px;
            background:url(${menteeMatchArrow1}) left top no-repeat;
            background-size:contain;
            z-index:9;
                @media( max-width:1024px ){
                    width:60px;
                    right:-30px;
                }
                @media( max-width:640px ){
                    right:-50px;
                }
        }
        &:last-child:after {
            content:'';
            position:absolute;
            left:-70px;
            top:0px;
            width:80px;
            height:39px;
            background:url(${menteeMatchArrow2}) left top no-repeat;
            background-size:contain;
            z-index:9;
                @media( max-width:1024px ){
                    width:60px;
                    left:-10px;
                }
                @media( max-width:640px ){
                    left:-20px;
                }
        }
`;



export const InfoImage = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    img{
        border-radius: 50%
    }
`;

export const Info = styled.div`
`;

export const InfoName = styled.h3`
    color: #302F2F;
    text-align: center;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
`;

export const InfoRole = styled.p`
    color: #757575;
    text-align: center;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0;
`;